import {propsReducer} from "utils/stateUtils";
import {HOLIDAY_SET_PROPS} from "actions";

const DEFAULT_STATE = {
  holidays:[],
  holidayDetails:null
};

export default propsReducer(HOLIDAY_SET_PROPS, DEFAULT_STATE);
